(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ChannelConfDialogController', ChannelConfDialogController);

    ChannelConfDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'ChannelConf'];

    function ChannelConfDialogController ($scope, $stateParams, $uibModalInstance, entity, ChannelConf) {
        var vm = this;

        vm.channelConf = entity;
        vm.channels = [];
        vm.configurationFields = {};
        vm.configurationError = null;
        vm.providerFieldConfigs = {
            SMS_ORACOM: [
                { key: 'fromLabel', label: 'Sender / fromLabel', placeholder: 'Sender par defaut Oracom' },
                { key: 'userName', label: 'Login / userName', placeholder: 'Compte Oracom' },
                { key: 'token', label: 'Token / mot de passe', placeholder: 'Token Oracom', inputType: 'password' },
                { key: 'limit30Days', label: 'Quota 30 jours', placeholder: 'Ex: 200', inputType: 'number' }
            ],
            SMS_PHILSMS: [
                { key: 'fromLabel', label: 'Sender ID', placeholder: '11 caracteres max' },
                { key: 'token', label: 'API token', placeholder: 'Bearer token PhilSMS', inputType: 'password' },
                { key: 'limit30Days', label: 'Quota 30 jours', placeholder: 'Ex: 200', inputType: 'number' }
            ],
            SMS_BULKSMSBD: [
                { key: 'fromLabel', label: 'Sender ID', placeholder: 'Sender ID approuve' },
                { key: 'token', label: 'API key', placeholder: 'Cle API BulkSMSBD', inputType: 'password' },
                { key: 'limit30Days', label: 'Quota 30 jours', placeholder: 'Ex: 200', inputType: 'number' }
            ],
            SMS_AWS: [
                { key: 'accessKey', label: 'AWS access key', placeholder: 'AKIA...' },
                { key: 'secretKey', label: 'AWS secret key', placeholder: 'Secret key', inputType: 'password' },
                { key: 'region', label: 'AWS region', placeholder: 'eu-west-1' },
                { key: 'fromLabel', label: 'Sender ID', placeholder: '3-11 caracteres, optionnel' },
                { key: 'smsType', label: 'SMS type', placeholder: 'Transactional ou Promotional' },
                { key: 'originationNumber', label: 'Origination number', placeholder: '+33123456789' },
                { key: 'maxPrice', label: 'Prix max USD', placeholder: '0.50' },
                { key: 'entityId', label: 'Entity ID (Inde)', placeholder: 'Optionnel' },
                { key: 'templateId', label: 'Template ID (Inde)', placeholder: 'Optionnel' },
                { key: 'limit30Days', label: 'Quota 30 jours', placeholder: 'Ex: 200', inputType: 'number' }
            ],
            WHATSAPP: [
                { key: 'userName', label: 'Phone number sender ID', placeholder: 'Identifiant emetteur WhatsApp' },
                { key: 'token', label: 'Access token', placeholder: 'Token Meta', inputType: 'password' },
                { key: 'limit30Days', label: 'Quota 30 jours', placeholder: 'Ex: 200', inputType: 'number' }
            ],
            EMAIL_SENDBLUE: [
                { key: 'host', label: 'URL API', placeholder: 'https://api.brevo.com/v3/smtp/email' },
                { key: 'port', label: 'Port', placeholder: '443', inputType: 'number' },
                { key: 'fromLabel', label: 'Nom expediteur', placeholder: 'Support' },
                { key: 'fromEmail', label: 'Email expediteur', placeholder: 'support@example.com' },
                { key: 'token', label: 'API key', placeholder: 'Cle API Brevo/Sendblue', inputType: 'password' },
                { key: 'limit30Days', label: 'Quota 30 jours', placeholder: 'Ex: 200', inputType: 'number' }
            ],
            EMAIL_SMTP: [
                { key: 'host', label: 'Serveur SMTP', placeholder: 'smtp.example.com' },
                { key: 'port', label: 'Port', placeholder: '587', inputType: 'number' },
                { key: 'startTls', label: 'STARTTLS', inputType: 'checkbox' },
                { key: 'userName', label: 'Utilisateur', placeholder: 'login SMTP' },
                { key: 'password', label: 'Mot de passe', placeholder: 'Mot de passe SMTP', inputType: 'password' },
                { key: 'fromLabel', label: 'Nom expediteur', placeholder: 'Support' },
                { key: 'fromEmail', label: 'Email expediteur', placeholder: 'support@example.com' },
                { key: 'limit30Days', label: 'Quota 30 jours', placeholder: 'Ex: 200', inputType: 'number' }
            ],
            TEST: [
                { key: 'limit30Days', label: 'Quota 30 jours', placeholder: 'Ex: 200', inputType: 'number' }
            ]
        };
        vm.providerExamples = {
            SMS_ORACOM: '{"fromLabel":"ACME","userName":"login","token":"secret","limit30Days":200}',
            SMS_PHILSMS: '{"fromLabel":"ACME","token":"api-token","limit30Days":200}',
            SMS_BULKSMSBD: '{"fromLabel":"ACME","token":"api-key","limit30Days":200}',
            SMS_AWS: '{"accessKey":"AKIA...","secretKey":"secret","region":"eu-west-1","fromLabel":"ACME","smsType":"Transactional","originationNumber":"+33123456789","maxPrice":"0.50","entityId":"","templateId":"","limit30Days":200}',
            WHATSAPP: '{"userName":"phoneNumberSenderId","token":"accessToken","limit30Days":200}',
            EMAIL_SENDBLUE: '{"host":"https://api.brevo.com/v3/smtp/email","port":443,"fromLabel":"Support","fromEmail":"support@example.com","token":"api-key","limit30Days":200}',
            EMAIL_SMTP: '{"host":"smtp.example.com","port":587,"startTls":true,"userName":"login","password":"secret","fromLabel":"Support","fromEmail":"support@example.com","limit30Days":200}',
            TEST: '{"limit30Days":200}'
        };
        vm.load = load;
        vm.save = save;
        vm.clear = clear;
        vm.onChannelChange = onChannelChange;
        vm.onStructuredFieldChange = onStructuredFieldChange;
        vm.onConfigurationTextChange = onConfigurationTextChange;
        vm.getVisibleConfigurationFields = getVisibleConfigurationFields;
        vm.getCurrentExample = getCurrentExample;

        vm.channels = ChannelConf.getChannel();
        initializeChannelConf(entity);

        function load(id) {
            ChannelConf.get({id : id}, function(result) {
                initializeChannelConf(result);
            });
        }

        function initializeChannelConf(channelConf) {
            vm.channelConf = channelConf || {};
            syncFieldsFromConfiguration();

            if (vm.channelConf.$promise) {
                vm.channelConf.$promise.then(function(result) {
                    vm.channelConf = result;
                    syncFieldsFromConfiguration();
                });
            }
        }

        function save() {
            vm.isSaving = true;
            syncConfigurationFromFields();
            if (vm.channelConf.id !== null) {
                ChannelConf.update(vm.channelConf, onSaveSuccess, onSaveError);
            } else {
                ChannelConf.save(vm.channelConf, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('wamasysApp:channelConfUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function onChannelChange() {
            syncConfigurationFromFields();
        }

        function onStructuredFieldChange() {
            syncConfigurationFromFields();
        }

        function onConfigurationTextChange() {
            syncFieldsFromConfiguration();
        }

        function getVisibleConfigurationFields() {
            return vm.providerFieldConfigs[vm.channelConf.channel] || [];
        }

        function getCurrentExample() {
            return vm.providerExamples[vm.channelConf.channel] || '{}';
        }

        function syncFieldsFromConfiguration() {
            var parsed = parseConfiguration(vm.channelConf.configuration);
            var knownKeys = getKnownKeys();
            var i;

            if (!parsed) {
                return;
            }

            vm.configurationError = null;
            for (i = 0; i < knownKeys.length; i++) {
                vm.configurationFields[knownKeys[i]] = angular.isDefined(parsed[knownKeys[i]]) ? parsed[knownKeys[i]] : null;
            }
        }

        function syncConfigurationFromFields() {
            var parsed = parseConfiguration(vm.channelConf.configuration) || {};
            var knownKeys = getKnownKeys();
            var i;
            var key;
            var value;

            for (i = 0; i < knownKeys.length; i++) {
                key = knownKeys[i];
                value = normalizeFieldValue(key, vm.configurationFields[key]);
                if (hasValue(value)) {
                    parsed[key] = value;
                } else {
                    delete parsed[key];
                }
            }

            vm.configurationError = null;
            vm.channelConf.configuration = angular.toJson(parsed, true);
        }

        function parseConfiguration(configurationText) {
            if (!configurationText || !configurationText.trim()) {
                return {};
            }

            try {
                return angular.fromJson(configurationText);
            } catch (e) {
                vm.configurationError = 'JSON invalide';
                return null;
            }
        }

        function getKnownKeys() {
            var keys = [];
            angular.forEach(vm.providerFieldConfigs, function(fields) {
                angular.forEach(fields, function(field) {
                    if (keys.indexOf(field.key) === -1) {
                        keys.push(field.key);
                    }
                });
            });
            return keys;
        }

        function normalizeFieldValue(key, value) {
            if (key === 'limit30Days' || key === 'port') {
                return hasValue(value) ? Number(value) : null;
            }
            if (key === 'startTls') {
                return value === true;
            }
            return value;
        }

        function hasValue(value) {
            return value !== null && value !== undefined && value !== '';
        }
    }
})();
